import { Component, OnInit } from '@angular/core';
import { BsModalService } from "ngx-bootstrap/modal";
import { StorageService } from 'src/app/features/http-services/storage.service';
@Component({
  selector: 'app-switch-tab-modal',
  templateUrl: './switch-tab-modal.component.html',
  styleUrls: ['./switch-tab-modal.component.scss']
})
export class SwitchTabModalComponent implements OnInit {
  onAction: Function = () => { };

  constructor(private modalService: BsModalService,
              private storageService: StorageService
  ) { 
    
  }

  handleAction() {
    this.onAction();
    this.modalService.hide("switchtab");
    this.storageService.handleTriggerClearUnit();
  }

  ngOnInit(): void { }
}

